window.PlummeI18n.register('no', {
  'demoReset.button': 'Nullstill demo',
  'demoReset.title': 'Nullstill demoselskapet',
  'demoReset.message': 'Dette sletter permanent alle regnskaps- og driftsdata i dette demoselskapet. Handlingen kan ikke angres.',
  'demoReset.preserved': 'Foretaksprofilen, medlemmer, abonnement og integrasjonskoblinger beholdes.',
  'demoReset.phrase': 'BEKREFT',
  'demoReset.typeLabel': 'Skriv {phrase} for å aktivere nullstilling',
  'demoReset.typeHint': 'Kontroller at riktig demoselskap er valgt før du fortsetter.',
  'demoReset.confirm': 'Slett og nullstill demo',
  'demoReset.complete': 'Demoselskapet er nullstilt.',
  'demoReset.failed': 'Kunne ikke nullstille demoselskapet.',
  'demoReset.reason': 'Brukeren bekreftet hurtig-nullstilling av demoselskapet ved å skrive det påkrevde bekreftelsesordet.',
  'demoReset.settingTitle': 'Vis hurtigknapp for nullstilling',
  'demoReset.settingHelp': 'Viser «Nullstill demo» over SuperPlumma for dette selskapet. Andre selskaper på demokontoen styres separat.',
  'demoReset.settingEnabled': 'Hurtigknappen er aktivert for dette demoselskapet.',
  'demoReset.settingDisabled': 'Hurtigknappen er deaktivert.',
});

window.PlummeI18n.register('en', {
  'demoReset.button': 'Reset demo',
  'demoReset.title': 'Reset the demo business',
  'demoReset.message': 'This permanently deletes all accounting and operating data in this demo business. This cannot be undone.',
  'demoReset.preserved': 'The business profile, members, subscription and integration connections are kept.',
  'demoReset.phrase': 'CONFIRM',
  'demoReset.typeLabel': 'Type {phrase} to enable reset',
  'demoReset.typeHint': 'Check that the correct demo business is selected before continuing.',
  'demoReset.confirm': 'Delete and reset demo',
  'demoReset.complete': 'The demo business has been reset.',
  'demoReset.failed': 'Could not reset the demo business.',
  'demoReset.reason': 'The user confirmed the demo-business reset shortcut by typing the required confirmation phrase.',
  'demoReset.settingTitle': 'Show reset shortcut',
  'demoReset.settingHelp': 'Shows “Reset demo” above SuperPlumma for this business. Other businesses on the demo account are configured separately.',
  'demoReset.settingEnabled': 'The shortcut is enabled for this demo business.',
  'demoReset.settingDisabled': 'The shortcut is disabled.',
});
